import DashboardTodoPanel from "./DashboardTodoPanel";
import { ManagementWidgetShell } from "../managementDashboardWidgets";
import { pick } from "../managementDashboardUtils";

/**
 * Iran distribution map shell — renders live data when GetDistributionMap is available,
 * otherwise shows API TODO (no mock data).
 */
const IranDistributionMapSection = ({ loading, error, data, onRetry }) => {
  const isAvailable = pick(data, "isAvailable", "IsAvailable");
  const provinces = data?.provinces || data?.Provinces || [];

  if (!isAvailable && !loading && !error) {
    return (
      <DashboardTodoPanel
        title="نقشه ایران"
        futureEndpoints={["GetDistributionMap"]}
        description="نمایش توزیع درخواست، ظرفیت، قرارداد و نیروگاه نصب‌شده روی نقشه — پس از API."
      />
    );
  }

  return (
    <ManagementWidgetShell
      title="نقشه توزیع ایران"
      subheader="توزیع جغرافیایی درخواست‌ها"
      loading={loading}
      error={error}
      onRetry={onRetry}
    >
      {provinces.length ? (
        <DashboardTodoPanel
          title="نقشه choropleth"
          futureEndpoints={["GetDistributionMap — GeoJSON layer"]}
          description={`${provinces.length} استان از API دریافت شد — لایه نقشه در فاز بعدی.`}
        />
      ) : (
        pick(data, "unavailableReason", "UnavailableReason") || "داده نقشه در دسترس نیست."
      )}
    </ManagementWidgetShell>
  );
};

export default IranDistributionMapSection;
